import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import OpenAIBadge from "@/components/OpenAIBadge";

export default function OpenAIMasthead() {
  return (
    <section
      className="relative overflow-hidden bg-[#050505] text-white"
      data-testid="openai-masthead"
    >
      {/* futuristic grid */}
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "linear-gradient(rgba(16,163,127,0.18) 1px, transparent 1px), linear-gradient(90deg, rgba(16,163,127,0.18) 1px, transparent 1px)",
          backgroundSize: "42px 42px",
          maskImage:
            "radial-gradient(ellipse at 50% 40%, black 40%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at 50% 40%, black 40%, transparent 80%)",
        }}
      />
      <div className="absolute -top-24 -left-16 h-72 w-72 rounded-full bg-[#10a37f]/25 blur-3xl" />
      <div className="absolute -bottom-24 right-1/4 h-56 w-56 rounded-full bg-[#10a37f]/20 blur-3xl" />

      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 pt-24 md:pt-24 pb-7 md:pb-9 flex flex-col lg:flex-row items-center gap-6 lg:gap-10">
        <div className="shrink-0">
          <OpenAIBadge size={120} />
        </div>

        <div className="flex-1 text-center lg:text-left">
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 rounded-full border border-[#10a37f]/40 bg-[#10a37f]/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.28em] text-[#34d399]"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-[#34d399] animate-pulse" />
            New · OpenAI Ads Partnership
          </motion.div>

          <h2 className="mt-3 font-display text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter leading-[0.95]">
            <span className="bg-gradient-to-r from-white via-gray-300 to-gray-500 bg-clip-text text-transparent">
              Verified OpenAI Ads Partner
            </span>
          </h2>
          <p className="mt-2 font-body text-white/70 text-sm md:text-base max-w-[46ch] mx-auto lg:mx-0">
            One of the few exclusive OpenAI Ads partners in India.
          </p>

          <div className="mt-5 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
            <Link
              to="/openai-partner"
              data-testid="masthead-cta"
              className="group inline-flex items-center gap-3 rounded-full bg-[#10a37f] pl-6 pr-2.5 py-3 text-black font-body font-bold shadow-[0_0_40px_-8px_rgba(16,163,127,0.7)] hover:shadow-[0_0_60px_-8px_rgba(52,211,153,0.9)] transition-shadow"
            >
              Explore Exclusive AI Ads
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-black transition-transform duration-500 group-hover:rotate-45">
                <ArrowUpRight className="h-4 w-4 text-[#34d399]" />
              </span>
            </Link>
            <div className="inline-flex items-center gap-2 text-xs font-body font-semibold text-[#34d399] max-w-[38ch]">
              <span className="h-2 w-2 rounded-full bg-[#34d399] animate-pulse shadow-[0_0_10px_#34d399]" />
              Limited Capacity: Only accepting 5 new AI Ads clients this month.
            </div>
          </div>
        </div>
      </div>

      {/* silver divider */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-[#a1a1aa]/50 to-transparent" />
    </section>
  );
}
